export const DEFAULT_PAGE = 1
export const DEFAULT_PAGE_SIZE = 28
export const STALE_TIME_24_HOURS = 24 * 60 * 60 * 1000
